// src/store/slices/productSlice.js
import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  products: [],
  currentProduct: null,
  featuredProducts: [],
  relatedProducts: [],
  total: 0,
  page: 1,
  limit: 20,
  loading: false,
  error: null,
  filters: {
    category: null,
    minPrice: null,
    maxPrice: null,
    inStock: null,
    rating: null,
    sort: 'newest',
    search: '',
  },
};

const productSlice = createSlice({
  name: 'products',
  initialState,
  reducers: {
    setProducts: (state, action) => {
      state.products = action.payload.products;
      state.total = action.payload.total || action.payload.products.length;
    },
    setCurrentProduct: (state, action) => {
      state.currentProduct = action.payload;
    },
    setFeaturedProducts: (state, action) => {
      state.featuredProducts = action.payload;
    },
    setRelatedProducts: (state, action) => {
      state.relatedProducts = action.payload;
    },
    addProduct: (state, action) => {
      state.products.unshift(action.payload);
      state.total += 1;
    },
    updateProduct: (state, action) => {
      const index = state.products.findIndex(
        (p) => p.id === action.payload.id
      );
      if (index !== -1) {
        state.products[index] = action.payload;
      }
      if (state.currentProduct?.id === action.payload.id) {
        state.currentProduct = action.payload;
      }
    },
    deleteProduct: (state, action) => {
      state.products = state.products.filter(
        (p) => p.id !== action.payload
      );
      state.total -= 1;
      if (state.currentProduct?.id === action.payload) {
        state.currentProduct = null;
      }
    },
    setPage: (state, action) => {
      state.page = action.payload;
    },
    setLimit: (state, action) => {
      state.limit = action.payload;
    },
    setFilters: (state, action) => {
      state.filters = {
        ...state.filters,
        ...action.payload,
      };
    },
    resetFilters: (state) => {
      state.filters = {
        category: null,
        minPrice: null,
        maxPrice: null,
        inStock: null,
        rating: null,
        sort: 'newest',
        search: '',
      };
    },
    setLoading: (state, action) => {
      state.loading = action.payload;
    },
    setError: (state, action) => {
      state.error = action.payload;
    },
    clearError: (state) => {
      state.error = null;
    },
    resetProductState: (state) => {
      return initialState;
    },
  },
});

// Actions
export const {
  setProducts,
  setCurrentProduct,
  setFeaturedProducts,
  setRelatedProducts,
  addProduct,
  updateProduct,
  deleteProduct,
  setPage,
  setLimit,
  setFilters,
  resetFilters,
  setLoading,
  setError,
  clearError,
  resetProductState,
} = productSlice.actions;

// Selectors
export const selectProducts = (state) => state.products.products;
export const selectCurrentProduct = (state) => state.products.currentProduct;
export const selectFeaturedProducts = (state) => state.products.featuredProducts;
export const selectRelatedProducts = (state) => state.products.relatedProducts;
export const selectTotalProducts = (state) => state.products.total;
export const selectProductPage = (state) => state.products.page;
export const selectProductLimit = (state) => state.products.limit;
export const selectProductFilters = (state) => state.products.filters;
export const selectProductLoading = (state) => state.products.loading;
export const selectProductError = (state) => state.products.error;

export default productSlice.reducer;